import { render, staticRenderFns } from "./yuanxiaoku.vue?vue&type=template&id=3aae50b4&scoped=true"
import script from "./yuanxiaoku.vue?vue&type=script&lang=js"
export * from "./yuanxiaoku.vue?vue&type=script&lang=js"
import style0 from "./yuanxiaoku.vue?vue&type=style&index=0&id=3aae50b4&prod&lang=less&scoped=true"
import style1 from "./yuanxiaoku.vue?vue&type=style&index=1&id=3aae50b4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aae50b4",
  null
  
)

export default component.exports